import { Directive } from 'vue'
import moment from 'moment'

const basicDateDirective: Directive = {
  mounted(el, binding) {
    const date = binding.value
    const formattedDate = moment.utc(date).format('DD/MM/YYYY')
    el.textContent = formattedDate
  },
}

export default basicDateDirective
